var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 115,
    viewBox: "0 0 124 115",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80.5613 15.6405C75.8483 10.5521 69.2656 7.75 62 7.75C54.6956 7.75 48.0912 10.5352 43.4 15.592C38.658 20.7046 36.3475 27.653 36.89 35.156C37.9653 49.9585 49.2295 62 62 62C74.7706 62 86.0153 49.9609 87.1076 35.1608C87.6574 27.7256 85.3324 20.7918 80.5613 15.6405ZM104.625 116.25H19.375C18.2591 116.265 17.1541 116.03 16.1402 115.564C15.1264 115.098 14.2292 114.411 13.514 113.555C11.9398 111.673 11.3053 109.103 11.7751 106.504C13.8192 95.1652 20.1984 85.64 30.225 78.9532C39.1327 73.0172 50.4162 69.75 62 69.75C73.5838 69.75 84.8674 73.0196 93.775 78.9532C103.802 85.6376 110.181 95.1628 112.225 106.502C112.695 109.101 112.06 111.67 110.486 113.552C109.771 114.409 108.874 115.096 107.86 115.563C106.846 116.03 105.741 116.264 104.625 116.25Z",
    fill: "url(#paint0_linear_557_23046)",
    fillOpacity: 0.71
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_557_23046",
    x1: 62,
    y1: 8,
    x2: 62,
    y2: 164.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.192308,
    stopColor: "#506BEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8243E3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.f5c1d1f8c63743caa56bd68d318c43c2.svg";
export { ForwardRef as ReactComponent };